import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const ChevronExpandBase = (
  <g fill='none' fillRule='evenodd' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2'>
    <path d='M2 10L6 14 2 18' transform='translate(-168 -815) translate(0 774) translate(168 41) translate(8 4) rotate(90 4 14)' />
    <path d='M2 -2L6 2 2 6' transform='translate(-168 -815) translate(0 774) translate(168 41) translate(8 4) matrix(0 -1 -1 0 6 6)' />
  </g>
)

export const ChevronExpand = createIcon({
  displayName: 'ChevronExpand',
  viewBox: '0 0 24 24',
  path: ChevronExpandBase,
})
